export const createDateOfBirthStringFromObject = (dobObject) => {
  if (dobObject?.dobDay && dobObject?.dobMonth && dobObject?.dobYear) {
    return `${dobObject.dobYear}-${dobObject.dobMonth}-${dobObject.dobDay}`;
  }
  return null;
};

export default createDateOfBirthStringFromObject;
